/// BPMNPaletteItems: Categorized BPMN element definitions for the palette.
/// Four categories: Events, Tasks, Gateways, Structure.

// ---------------------------------------------------------------------------
// Palette item type
// ---------------------------------------------------------------------------

export interface PaletteItemDef {
  type: string;
  label: string;
  icon: string;
}

export interface PaletteCategory {
  name: string;
  color: string; // Tailwind color class (e.g., "green", "blue")
  items: PaletteItemDef[];
}

// ---------------------------------------------------------------------------
// BPMN palette categories
// ---------------------------------------------------------------------------

export const bpmnPaletteCategories: PaletteCategory[] = [
  {
    name: "Events",
    color: "green",
    items: [
      { type: "startEvent", label: "Start Event", icon: "circle" },
      { type: "endEvent", label: "End Event", icon: "circle-dot" },
      { type: "timerEvent", label: "Timer Event", icon: "clock" },
      { type: "messageEvent", label: "Message Event", icon: "mail" },
      { type: "signalEvent", label: "Signal Event", icon: "radio" },
      { type: "errorEvent", label: "Error Event", icon: "alert-triangle" },
      { type: "terminateEvent", label: "Terminate Event", icon: "x-circle" },
    ],
  },
  {
    name: "Tasks",
    color: "blue",
    items: [
      { type: "task", label: "Task", icon: "square" },
      { type: "serviceTask", label: "Service Task", icon: "settings" },
      { type: "userTask", label: "User Task", icon: "user" },
      { type: "scriptTask", label: "Script Task", icon: "code" },
      { type: "sendTask", label: "Send Task", icon: "send" },
      { type: "receiveTask", label: "Receive Task", icon: "inbox" },
    ],
  },
  {
    name: "Gateways",
    color: "orange",
    items: [
      { type: "exclusiveGateway", label: "Exclusive Gateway", icon: "diamond" },
      { type: "parallelGateway", label: "Parallel Gateway", icon: "diamond-plus" },
      { type: "inclusiveGateway", label: "Inclusive Gateway", icon: "diamond" },
      { type: "eventBasedGateway", label: "Event-Based Gateway", icon: "diamond" },
    ],
  },
  {
    name: "Structure",
    color: "purple",
    items: [
      { type: "subprocess", label: "Subprocess", icon: "box" },
      { type: "callActivity", label: "Call Activity", icon: "external-link" },
      { type: "pool", label: "Pool", icon: "columns" },
      { type: "lane", label: "Lane", icon: "minus" },
    ],
  },
];
